// extracted by mini-css-extract-plugin
export default {"primary":"StatusBoxRow_primary__wMtn7","secondary":"StatusBoxRow_secondary__TWaLI"};